import ConversionPolicy from './ConversionPolicy.container';

export default ConversionPolicy;
